import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { BehaviorSubject } from "rxjs";
import { Observable } from "rxjs";
import { LogService } from "../logger/loggerProvider/loggerhelper.service";
declare var $: any; //JQuery handle for SignalR

const enum ConnectionState {
    Connecting = 0,
    Connected = 1,
    Reconnecting = 2,
    Disconnected = 4
}

interface ConnectionError extends Error {
    context: any;
    transport?: string;
    source?: string;
}

interface StateChanged {
    oldState: number;
    newState: number;
}

@Injectable()
export class HubConnection {

    public connectionStarted: Subject<boolean> = new Subject<boolean>();
    public _connected: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    private _connectionState: BehaviorSubject<ConnectionState> = new BehaviorSubject<ConnectionState>(ConnectionState.Disconnected);
    private errorSubject: Subject<ConnectionError> = new Subject<ConnectionError>();
    private hubConnection: any;

    private static convertState(state: number): string {
        if (state === ConnectionState.Connecting) {
            return "Connecting";
        }
        else if (state === ConnectionState.Connected) {
            return "Connected";
        }
        else if (state === ConnectionState.Reconnecting) {
            return "Reconnecting";
        }
        else if (state === ConnectionState.Disconnected) {
            return "Disconnected";
        }
        else {
            return "Unknown";
        }
    }

    public get connectionState(): Observable<any> {
        return this._connectionState.asObservable();
    }

    public get isDisconnected(): boolean {
        return this._connectionState.getValue() === ConnectionState.Disconnected ? true : false;
    }

    public get isConnected(): boolean {
        return this._connectionState.getValue() === ConnectionState.Connected ? true : false;
    }

    public get connected(): Observable<boolean> {
        return this._connected.asObservable();
    }

    constructor(public clientId: string, private loggerHelper: LogService) {
    }

    public initHubConnection(url: string): void {
        try {
            if ($ === undefined || $.hubConnection === undefined) {
                this.loggerHelper.logError(HubConnection.name, "The variable '$' or the .hubConnection() function are not defined; Please check the SignalR scripts have been loaded properly");
                throw new Error("The variable '$' or the .hubConnection() function are not defined; Please check the SignalR scripts have been loaded properly");
            }
        } catch (error) {
            this.loggerHelper.logError(HubConnection.name, "The variable '$' or the .hubConnection() function are not defined, Please check the SignalR scripts have been loaded properly");
            throw new Error("The variable '$' or the .hubConnection() function are not defined, Please check the SignalR scripts have been loaded properly");
        }

        this.hubConnection = $.hubConnection();
        this.hubConnection.url = url;
        this.hubConnection.stateChanged((state: StateChanged) => {
            this.loggerHelper.logInfo(HubConnection.name, "Hub Connection state changed from "+ HubConnection.convertState(state.oldState)  + " to " + HubConnection.convertState(state.newState) );
            this._connectionState.next(state.newState);
            if (state.newState === ConnectionState.Connected) {
                this._connected.next(true);
            }
            else {
                this._connected.next(false);
            }
        });

        this.hubConnection.error((error: ConnectionError) => {
            this.loggerHelper.logError(HubConnection.name, "Hub Connection error :" + error);
            this.errorSubject.next(error);
        });
    }

    public getHubProxy(hubName: string): any {
        let name: string = hubName.toLowerCase(); // signalr creates proxies with lowser case names!
        if (this.hubConnection.proxies[name] == undefined) {
            this.hubConnection.createHubProxy(name);
        }
        return this.hubConnection.proxies[name];
    }

    public get connectionId(): string {
        return this.hubConnection.id;
    }

    public startHubConnection(): void {
        if (this._connectionState.getValue() !== ConnectionState.Disconnected) {
            return;
        }
        this.hubConnection.start()
            .done(() => {
                this.loggerHelper.logInfo(HubConnection.name, "Hub Connection done");
                this.connectionStarted.next(true);
                this.connectionStarted.complete();
            })
            .fail((error: any) => {
                this.loggerHelper.logInfo(HubConnection.name, "Hub Connection failed");
                this.connectionStarted.error(error);
            });
    }
}
